import styled from 'styled-components';

import { DialogueBox } from '../../styles/style';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled(DialogueBox)``;

export const Fieldset = styled.fieldset`
  border: 0;
  margin: 1rem 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  padding: 0.5em;
  label,
  input {
    padding: 0.5em;
    display: inline-block;
  }
  input {
    flex: 2;
  }
  label {
    padding: 0.5em 1em 0.5em 0;
    flex: 1;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .crossLink {
  }
  .button {
    margin-bottom: 1rem;
  }
`;
